import React from "react";
import { Toaster } from "sonner";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const DISCORD_URL = "https://discord.gg/nEvwBUtqAV";

const SECTIONS = [
  {
    title: "1. What we collect",
    body: "Only what we need to run the platform: email, username, password (hashed), your avatar / team logos if you upload them, tournaments you create or join, match results, and basic session data (IP, timestamps) used to secure your account.",
  },
  {
    title: "2. Why we collect it",
    body: "To create your account, let you join tournaments, sync bracket updates in real time, send you transactional notifications, and prevent abuse. We do not sell or rent your data.",
  },
  {
    title: "3. Cookies & local storage",
    body: "We store a JWT in your browser's local storage to keep you logged in. We don't use third-party advertising trackers.",
  },
  {
    title: "4. Who can see what",
    body: "Your username, team name, team logo, and match results are public inside a tournament. Your email is visible only to you and to admins. Banners / cover images you upload are public.",
  },
  {
    title: "5. Data you can delete",
    body: "You can leave a tournament at any time before it goes live. Admins can remove your account at your request — email us via the Support page. Deleting your account removes your teams from all tournaments and frees your email for a fresh signup.",
  },
  {
    title: "6. Security",
    body: "Passwords are hashed with bcrypt. API is HTTPS-only. Admin access is role-gated and logged. If we detect a breach we'll notify affected users within 72h.",
  },
  {
    title: "7. Children",
    body: "Spicy Community isn't directed at children under 13. If you believe a child under 13 has registered, contact us and we'll delete the account.",
  },
  {
    title: "8. Contact",
    body: "Privacy questions? Reach us in our Discord #support channel or via the in-app Support page.",
  },
];

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-[#050505] text-zinc-200">
      <Toaster position="top-right" theme="dark" />
      <Navbar />
      <section className="max-w-4xl mx-auto px-6 pt-12 pb-20">
        <div className="text-[10px] uppercase tracking-[0.3em] text-red-400 font-mono mb-3">
          Spicy Community
        </div>
        <h1 className="font-display font-extrabold text-4xl md:text-5xl mb-3">
          Privacy <span className="text-red-500">Policy</span>
        </h1>
        <p className="text-zinc-400 max-w-2xl">
          Short version: we collect the minimum needed to run the platform, we don't sell
          your data, and you can delete your account any time.
        </p>
        <div className="mt-10 space-y-5">
          {SECTIONS.map((s, i) => (
            <div key={i} className="glass-dark rounded-2xl p-6">
              <h2 className="font-display font-bold text-lg mb-1.5 text-white">{s.title}</h2>
              <p className="text-sm leading-relaxed text-zinc-400">{s.body}</p>
            </div>
          ))}
        </div>
        <p className="text-xs text-zinc-500 mt-10">Last updated: April 2026</p>
      </section>
      <Footer discordUrl={DISCORD_URL} />
    </div>
  );
}
